import { render, staticRenderFns } from "./save-paper-info.html?vue&type=template&id=468f0b44&scoped=true&external"
import script from "./save-paper-info.js?vue&type=script&lang=js&external"
export * from "./save-paper-info.js?vue&type=script&lang=js&external"
import style0 from "./save-paper-info.scss?vue&type=style&index=0&id=468f0b44&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468f0b44",
  null
  
)

export default component.exports